import { PaymentRequestStatus, ReceiptAllocationStatus } from '../../../../constants/request';
import { TextLabel } from 'neon-design-system';

interface Props {
    status: PaymentRequestStatus | ReceiptAllocationStatus;
}

export const CashMovementStatusLabel = ({ status }: Props) => {
    switch (status) {
        case PaymentRequestStatus.PENDING:
            return <TextLabel label="Pending" styleName="default" />;
        case PaymentRequestStatus.NOTPAID:
            return <TextLabel label="Unpaid" styleName="error" />;
        case PaymentRequestStatus.PAID:
            return <TextLabel label="Paid" styleName="success" />;
        case ReceiptAllocationStatus.ALLOCATED:
            return <TextLabel label="Allocated" styleName="success" />;
        default:
            return null;
    }
};
